import { render } from "./TicketsNewOpenChart.vue?vue&type=template&id=37bcb95c&ts=true"
import script from "./TicketsNewOpenChart.vue?vue&type=script&lang=ts"
export * from "./TicketsNewOpenChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__